import { Permission, UserData, Module, DomainType } from '@models/index.model';

export class CheckDomainRequest {
  username: string;
  consumer: string;
  domainToReturn: string;
}
export class LoginRequest {
  username: string;
  password: string;
  consumer: Consumer;
}

export class UserAuth {
  refreshToken: string;
  accessToken: string;
  expiration: Date;
}

export class LoginResponse {
  refreshToken: string;
  accessToken: string;
  expiration: Date;
  sessionConfig: SessionConfig;
}

export class UserSession {
  userAuth: UserAuth;
  userData: UserData;
  userPermissions: Permission[];
  userModules: Module[];
}

export class SessionConfig {
  friendlyName: string;
  email: string;
  language: string;
  domainName: string;
  domainType: DomainType;
  permissions: Permission[];
  modules: Module[];
}

export class PasswordRequest {
  username: string;
  password: string;
  newPassword: string;
}

export class PasswordResponse {}

export class LoginByTokenRequest {
  token: string;
  consumer: Consumer;
}

export class LoginByCertificateRequest {
  consumer: Consumer;
}

export class LogoutResponse {}

export class RefreshTokenRequest {
  refreshToken: string;
}

export enum Consumer {
  AUTH = 'AUTH',
  PERSONAL_AREA = 'PERSONAL_AREA',
  AGENT = 'AGENT',
  SIGNTRUST_APP = 'SIGNTRUST_APP',
  GLOBAL_PERSONAL_AREA = 'GLOBAL_PERSONAL_AREA',
}

export enum LocalStorageKeys {
  SESSION_KEY = 'PersonalUserSession',
  MOBILE_HOST_URL = 'mobileApiUrl',
  USER_PIN_SESSION = 'UserPinSession',
  USER_PIN_REDIRECT_ID = 'userPinRedirectId'
}

export enum LoginStep {
  HOST = 'host',
  USERNAME = 'username',
  PASSWORD = 'password',
  CONFIG_USER_PIN = 'configUserPin',
  FINISH = 'finish',
}
